import * as React from 'react';
import BaseButton from '../../common/BaseButton';
import { getBasePath } from '../../../utils/browser';

interface StampButtonProps {
  readonly onClick?: () => void;
  readonly imagesSrc: string;
  readonly href?: string;
  readonly style?: React.CSSProperties;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly active?: boolean;
  readonly disabled?: boolean;
  readonly margin?: boolean;
}

const imageBaseStyle: React.CSSProperties = {
  width: '40px',
  height: '40px',
};

const frameStyle: React.CSSProperties = {
  width: '42px',
  height: '42px',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '#676767 1px solid',
};

const imageFrameStyle: React.CSSProperties = {
  margin: '10px 12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const render =  (props: StampButtonProps, active?: boolean): JSX.Element => {
  const { style, imagesSrc } = props;
  const frameAdditionalStyle: React.CSSProperties = {};

  if (active) {
    const baseDir = getBasePath();
    const imgSrc = `${baseDir}/images/setting-popup/frame/select_frame_normal_01.png`;
    frameAdditionalStyle.margin = '5px 7px';
    frameAdditionalStyle.width = '52px';
    frameAdditionalStyle.height = '52px';
    frameAdditionalStyle.backgroundImage = `url(${imgSrc})`;
    frameAdditionalStyle.backgroundSize = 'contain';
  }

  return (
    <div style={{ ...imageFrameStyle, ...frameAdditionalStyle }}>
      <div style={frameStyle}>
        <img src={imagesSrc} style={{ ...style, ...imageBaseStyle }}/>
      </div>
    </div>
  );
};

const StampButton: React.SFC<StampButtonProps> = React.memo((props) => {
  const { onClick, href, title, ariaLabel, active, disabled } = props;

  return (
    <BaseButton
      render={ () => render(props, active)}
      onClick={onClick}
      href={href}
      title={title}
      ariaLabel={ariaLabel}
      active={active}
      disabled={disabled} />
  );
});

export default StampButton;
